import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c6b6636")

_pushScopeId("data-v-7c6b6636")
const _hoisted_1 = {
  key: 0,
  class: "info"
}
const _hoisted_2 = { class: "img-wrap" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_ctx.isShow)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            class: "icon",
            spriteUrl: _ctx.link,
            name: _ctx.iconName
          }, null, 8, ["spriteUrl", "name"])
        ]),
        _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.text), 1)
      ]))
    : _createCommentVNode("", true)
})